import * as actionTypes from './../types/cartTypes'

const INITIAL_STATE = {
    cart: [],
}

const cartReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case actionTypes.ADD_TO_CART:
            return {
                ...state,
                cart: [...state.cart, action.payload.item]
            }

        case actionTypes.REMOVE_FROM_CART:
            return {
                ...state,
                cart: state.cart.filter(item => item.guid !== action.payload.guid)
            }

        case actionTypes.ADJUST_QTY:
            return {
                ...state,
                cart: state.cart.map(item =>
                    item.UID === action.payload.UID
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                )
            }

        default:
            return state
    }
}

export default cartReducer